var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "photos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.86,12.3737278 C7.44093959,12.3737278 6.29056383,11.225272 6.29056383,9.80857988 C6.29056383,8.3918878 7.44093959,7.24343195 8.86,7.24343195 C10.2790604,7.24343195 11.4294362,8.3918878 11.4294362,9.80857988 C11.4294362,11.225272 10.2790604,12.3737278 8.86,12.3737278 Z M16.4837447,3.9508284 C16.9538191,3.9508284 17.3371809,4.32899408 17.3417447,4.80284024 L17.3417447,15.0543195 C17.3417447,15.5281657 16.958383,15.9108876 16.4837447,15.9108876 L1.08081915,15.9108876 C0.606180851,15.9108876 0.222819149,15.5281657 0.222819149,15.0543195 L0.222819149,4.80284024 C0.222819149,4.32899408 0.606180851,3.94627219 1.08081915,3.94627219 L4.50369149,3.94627219 L5.22021277,1.21710059 C5.3023617,0.816153846 5.6537766,0.529112426 6.05995745,0.529112426 L11.5000426,0.529112426 C11.9107872,0.529112426 12.2576383,0.816153846 12.3397872,1.21710059 L13.0608723,3.9508284 L16.4837447,3.9508284 Z M7.06856383,2.24224852 L7.06856383,3.9508284 L10.4914362,3.9508284 L10.4914362,2.24224852 L7.06856383,2.24224852 Z M8.78,14.2023077 C11.1440638,14.2023077 13.0608723,12.2886982 13.0608723,9.92857988 C13.0608723,7.56846154 11.1440638,5.65485207 8.78,5.65485207 C6.41593617,5.65485207 4.49912766,7.56846154 4.49912766,9.92857988 C4.49912766,12.2886982 6.41593617,14.2023077 8.78,14.2023077 Z M14.7723085,7.36798817 C15.242383,7.36798817 15.6303085,6.98526627 15.6303085,6.51142012 C15.6303085,6.03757396 15.2469468,5.65485207 14.7723085,5.65485207 C14.2976702,5.65485207 13.9143085,6.03757396 13.9143085,6.51142012 C13.9143085,6.98526627 14.2976702,7.36798817 14.7723085,7.36798817 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopUp-Profile",
    transform: "translate(-211.000000, -553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy-2",
    transform: "translate(211.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "photos",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.957cb90f50d8fd5513afc1d99fe79f6f.svg";
export { ForwardRef as ReactComponent };